import { Button, Checkbox, Form, Modal } from 'antd';
import React, { FC } from 'react';
import OWButton from '../ow_button/OWButton';

const FORM_ID = 'wo-print-options-form';

const labelCol = { span: 22 };

const WorkOrderPrintOptionsModal: FC<any> = ({
	onCancel,
	onSubmit,
	showPartsOption,
}): React.ReactElement => {
	const [form] = Form.useForm();

	const initialValues = {
		includeImages: true,
		includeServiceCalls: true,
		includeNotes: true,
		includeNTE: true,
		includeTasks: true,
		// Parts & Equipment is a supplier-only tab, so buyers are never offered the option.
		...(showPartsOption && { includeParts: true }),
	};

	return (
		<Modal
			visible={true}
			width={400}
			title={'Include following in pdf'}
			closable
			onCancel={onCancel}
			forceRender
			footer={[
				<Button onClick={onCancel} size="large">
					Cancel
				</Button>,
				<OWButton type="primary" size="large" key="submit" htmlType="submit" form={FORM_ID}>
					Print
				</OWButton>,
			]}
		>
			<Form
				id={FORM_ID}
				form={form}
				layout="horizontal"
				requiredMark={false}
				initialValues={initialValues}
				onFinish={onSubmit}
			>
				<Form.Item
					label="Include Images"
					name="includeImages"
					valuePropName="checked"
					labelAlign="left"
					labelCol={labelCol}
				>
					<Checkbox />
				</Form.Item>
				<Form.Item
					name="includeServiceCalls"
					label="Include Service Calls"
					valuePropName="checked"
					labelAlign="left"
					labelCol={labelCol}
				>
					<Checkbox />
				</Form.Item>
				<Form.Item
					name="includeNotes"
					label="Include Notes"
					valuePropName="checked"
					labelAlign="left"
					labelCol={labelCol}
				>
					<Checkbox />
				</Form.Item>
				<Form.Item
					name="includeNTE"
					label="Include NTE"
					valuePropName="checked"
					labelAlign="left"
					labelCol={labelCol}
				>
					<Checkbox />
				</Form.Item>
				<Form.Item
					name="includeTasks"
					label="Include Tasks"
					valuePropName="checked"
					labelAlign="left"
					labelCol={labelCol}
				>
					<Checkbox />
				</Form.Item>
				{showPartsOption ? (
					<Form.Item
						name="includeParts"
						label="Include Parts & Equipment"
						valuePropName="checked"
						labelAlign="left"
						labelCol={labelCol}
					>
						<Checkbox />
					</Form.Item>
				) : null}
			</Form>
		</Modal>
	);
};

export default WorkOrderPrintOptionsModal;
